import { PDFDocument, TextAlignment } from "pdf-lib";

//*Dentro del parametro "dataCodigoQR" se sustituirá por un parametro desestructurado para llenar el form con la info real.

const getFilledPdfBytes = (pdfTemplateBytes, dataContrato) => {
  return new Promise(async (resolve, reject) => {
    try {
      const pdfDoc = await PDFDocument.load(pdfTemplateBytes);

      const pdfForm = pdfDoc.getForm();

      const { nombre_cliente, firma_cliente, dia, mes, year, ciudad } =
        dataContrato;

      pdfForm.getFields().forEach(async (field) => {
        const name = field.getName();

        switch (name) {
          case "nombre_cliente":
          case "dia":
          case "mes":
          case "year":
          case "ciudad":
            pdfForm.getTextField(name).setAlignment(TextAlignment.Center);

            break;

          default:
            break;
        }

        switch (name) {
          case "nombre_cliente":
            pdfForm.getTextField(name).setText(nombre_cliente);
            // pdfForm.getTextField(name).setAlignment(TextAlignment.Center);
            break;

          case "dia":
            pdfForm.getTextField(name).setText(dia);
            // pdfForm.getTextField(name).setAlignment(TextAlignment.Center);
            break;

          case "mes":
            pdfForm
              .getTextField(name)
              .setText(`${mes}`);

            break;

          case "year":
             pdfForm.getTextField(name).setText(year);
            break;

          case "ciudad":
             pdfForm.getTextField(name).setText(ciudad);
            break;

          case "firma_cliente":
            const firmaCliente = await pdfDoc.embedPng(firma_cliente);

            pdfForm.getButton(name).setImage(firmaCliente);
            break;

          case "numeroTarjeta":
             pdfForm.getTextField(name).setText(dataContrato.numeroTarjeta);
            break;

            case "clabe":
             pdfForm.getTextField(name).setText(dataContrato.clabe);
            break;

            case "numeroTelefono":
             pdfForm.getTextField(name).setText(dataContrato.numeroTelefono);
            break;

             case "bank":
             pdfForm.getTextField(name).setText(dataContrato.bank);
            break;
            

          default:
            break;
        }

        // pdfForm.getTextField(name).updateAppearances(helveticaFont);
      });

      // pdfForm.flatten();

      resolve(await pdfDoc.save());
    } catch (error) {
      reject(error);
    }
  });
};

export default getFilledPdfBytes;
